import { createIcon } from '../shared'

const SaveIcon = createIcon(
  ({ color }) => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.7 16.895C10.3735 16.4216 11.1767 16.1676 12 16.1676C12.8233 16.1676 13.6265 16.4216 14.3 16.895L18 19.495V6.5C18 5.96957 17.7893 5.46086 17.4142 5.08579C17.0391 4.71071 16.5304 4.5 16 4.5H8C7.46957 4.5 6.96086 4.71071 6.58579 5.08579C6.21071 5.46086 6 5.96957 6 6.5V19.495L9.7 16.895ZM20 19.495C20 21.115 18.175 22.062 16.85 21.131L13.15 18.531C12.8132 18.2945 12.4116 18.1675 12 18.1675C11.5884 18.1675 11.1868 18.2945 10.85 18.531L7.15 21.131C5.825 22.062 4 21.115 4 19.495V6.5C4 5.43913 4.42143 4.42172 5.17157 3.67157C5.92172 2.92143 6.93913 2.5 8 2.5H16C17.0609 2.5 18.0783 2.92143 18.8284 3.67157C19.5786 4.42172 20 5.43913 20 6.5V19.495Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'SaveIcon',
)

export { SaveIcon }
